import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MdDialogModule} from '@angular/material';

import {ModalComponent} from './modal.component';

@NgModule({
  declarations: [ModalComponent],
  imports: [CommonModule, MdDialogModule],
  exports: [ModalComponent],
})
export class ModalModule {}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.module.ts